import { MAIN_SITE_LINK } from '../../constants';

export const buildDiscoverLink = (
    articleCategory?: string,
    articleSlug?: string
) => {
    if (!articleCategory || !articleSlug) {
        return `${MAIN_SITE_LINK}/discover/`;
    }

    return `${MAIN_SITE_LINK}/discover/${articleCategory}/${articleSlug}/`;
};
